angular.module('CarsSaraBo').factory('DataService', ['$resource', function ($resource) {
    return $resource('', {},
        {
            categories: {
                url: '../rest/data/category',
                method: 'GET',
                isArray: true,
                transformResponse: function (data, headersGetter, status) {
                    var result = [];
                    if (status == 200) {
                        angular.fromJson(data).forEach(function (item) {
                            result.push({code: item, name: item})
                        });
                    }
                    return result;
                }
            },
        }
    )
}
]);




//////////////////
// WEBPACK FOOTER
// ./public/app/models/data_service.js
// module id = 843
// module chunks = 3